exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr{cursor:pointer}.center{text-align:center}.pos{font-size:300%}.pos,.status{font-weight:700}.liftbox{margin-bottom:3em}.liftbox-header{text-align:center;opacity:1;padding:1em 0}.liftbox-bg{opacity:.7;background-color:#fff;height:100%}.liftbox-content{opacity:1;padding-bottom:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77504626","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Group.vue
// module id = 841
// module chunks = 0